
import { useState } from 'react';
import './Carousel.css';

function Carousel({ images }) {
    const [current, setCurrent] = useState(0);

    const slideRight = () => {
        setCurrent(current === images.length - 1 ? 0 : current + 1)

    };

    const slideLeft = () => {
        setCurrent(current === 0 ? images.length - 1 : current - 1)

    };
    console.log(current);
    return (
        <div className="carousel">
            <div className="carousel_wrapper">
                {images.map((image, index) => {
                    return (
                        <div
                            // className="carousel_card"
                            key={index}
                            className={index === current ? "carousel_card carousel_card_active" : "carousel_card"}
                        >
                            <img className="card_image" src={image.image} alt="" />
                            <div className="card_overlay">
                                <h2 className="Styles.card_title">{image.title}</h2>
                            </div>
                        </div>
                    );
                })}
                <div className="carousle_arrow_left" onClick={slideLeft}>&lsaquo;</div>
                <div className="carousle_arrow_right" onClick={slideRight}>&rsaquo;</div>
            </div>
        </div>
    );
}

export default Carousel
